export const API_ERROR_EVENT = 'api-error-alert';
export const API_DVC_ROOT = '/api/v1';
export const API_DEFAULT_BASE_URL =
  import.meta.env.REACT_APP_BASE_API_URL + API_DVC_ROOT;
